import React from "react";
import { useTranslation } from "react-i18next";
import * as Icons from "react-bootstrap-icons";

export default function SelectedProjectComponent({
  selectedProject,
  gotoProject,
  inDesignPage,
}) {
  const { t } = useTranslation();
  return (
    <div className="project-name">
      {!inDesignPage && (
        <>
          <span className="project-status-icon">
            {selectedProject && selectedProject !== "undefined" ? (
              <Icons.ClipboardCheck size={17} className="selected" />
            ) : (
              <Icons.ClipboardX size={17} className="not-selected" />
            )}
          </span>
          <span className="project-status-title">
            {`${t("selectedProject")} :`}
          </span>
        </>
      )}
      {selectedProject && selectedProject !== "undefined" ? (
        <span
          onClick={() => gotoProject("/dashboard/projects/list", inDesignPage)}
          className="project-status-name"
        >
          {selectedProject?.Name}
        </span>
      ) : (
        <>
          <span
            onClick={() => gotoProject("/dashboard/projects/list", false)}
            className="project-status-name"
          >
            {t("selectProject")}
          </span>
        </>
      )}
    </div>
  );
}
